<template>
  <AdRecordsPanel
    :filters="admin.recordFilters"
    :records="admin.records.value"
    :total="admin.recordPagination.total"
    :total-reward="admin.recordPagination.totalReward"
    :page="admin.recordPagination.page"
    :page-size="admin.recordPagination.size"
    :loading="admin.recordsLoading.value"
    :groups="admin.recordFilterGroups.value"
    :unique-ad-platforms="admin.uniqueAdPlatforms.value"
    :unique-ad-types="admin.uniqueAdTypes.value"
    :token="admin.token.value"
    :customer-name="admin.customerName"
    :remember-customers="admin.rememberCustomers"
    :on-clear-filters="admin.clearRecordFilters"
    description="后端筛选分页；可按用户ID / 设备ID检索；总金币为当前筛选合计"
    show-customer-filter
    show-customer-column
    @search="admin.searchRecords"
    @page-change="admin.onRecordPageChange"
  />
</template>

<script setup>
import { inject } from 'vue'
import AdRecordsPanel from '@/components/AdRecordsPanel.vue'

const admin = inject('admin')
</script>
